import * as React from 'react'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import { Avatar, Box, Button, Title } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { EmployeeProfileButton } from 'modules/reviews/components/EmployeeProfileButton'
import Table from 'modules/reviews/components/ReviewsReviewee/Table'
import { useReviewsSplitViewData } from 'modules/reviews/lib/useReviewsSplitData'
import { useQuestionGroups } from 'modules/reviews/pages/performance/ReviewsReviewee/useQuestionGroups'
import type Review from 'modules/reviews/store/models/v2/Review'

export default function ReviewUserIndexPage() {
  const { review, userId } = useOutletContext<{
    review: Review
    userId: number
  }>()
  const isAnonymous = review.isAnonymous
  const { id: formId } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { loading, questionGroups } = useQuestionGroups(Number(formId), userId)
  const splitViewData = useReviewsSplitViewData(questionGroups)
  const user = users.get(userId)
  const target = questionGroups[0] && questionGroups[0]!.target

  if (loading) return <Loading />

  const onClick = (id: number, userId: number) => {
    track(trackingEvents.reviews.viewComparison)
    navigate(
      navigation.performance.reviews.id.reviews.targetReviewers.splitView.fullPath({
        id: id,
        user_id: userId,
      })
    )
  }
  const reviewee = user || target
  return (
    <Box gap="s32">
      <Box gap="s16">
        <Title
          title={i18n.t('surveys.review.reviews.reviewee.title', {
            user: user ? user.preferredName : target!.fullName(),
          })}
          description={i18n.t('surveys.review.reviews.reviewee.description')}
          illustrationComponent={
            reviewee && (
              <Avatar size="s40" url={buildUrl(reviewee.avatar)} label={reviewee.fullName()} />
            )
          }
        >
          {user && (
            <Box flexDirection="row" gap="s16" alignItems="center">
              <EmployeeProfileButton user={user} />
            </Box>
          )}
        </Title>
      </Box>
      <Box gap="s16">
        <Box flexDirection="row" justifyContent="flexEnd">
          {splitViewData.canSeeSplitView &&
            splitViewData.selfQuestionGroupId &&
            splitViewData.managerQuestionGroupId && (
              <Button onClick={() => onClick(+review.id, userId)} iconName="more-options">
                {i18n.t('surveys.review.reviews.split_view.button')}
              </Button>
            )}
        </Box>
        <Table formId={Number(formId)} isAnonymous={isAnonymous} questionGroups={questionGroups} />
      </Box>
    </Box>
  )
}
